import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { providerRoles } from '../mockData/provider-roles';

const ProviderRolesApi = [rest.get(`${API_ROOT}providers-roles`, (req, res, ctx) => res(ctx.json(providerRoles)))];
export default ProviderRolesApi;
